export const strokeJoinMitterIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M3 3v17h2V5h15V3zm6 6v4h1v7h2v-7h1v-1h7v-2h-7V9zm6 6v5h2v-3h3v-2z"/></svg>`,
  name: 'stroke-join-mitter',
};
